import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-brand-cream" data-id="element-82">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-83">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-orange/5 rounded-full blur-3xl" data-id="element-84"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-brand-green/5 rounded-full blur-3xl" data-id="element-85"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-6xl" data-id="element-86">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-87">
          <div className="order-2 md:order-1 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-88">
            <FadeIn delay={0.1} data-id="element-89">
              <span className="inline-block py-1 px-3 rounded-full bg-brand-orange/10 text-brand-orange font-semibold text-sm tracking-wide mb-6 uppercase" data-id="element-90">
                Página de Venta: Reset Metabólico 45+
              </span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-91">
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-charcoal leading-tight mb-6" data-id="element-92">
                El Método Estratégico para Desbloquear tu Metabolismo después de
                los 45{' '}
                <span className="text-brand-orange italic" data-id="element-93">
                  (Sin Dietas de Hambre)
                </span>
                .
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-94">
              <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-95">
                Recuperá tu figura, tu energía y tu confianza sincronizando tus
                hormonas con este protocolo diseñado específicamente para la
                mujer de más de 45.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="w-full md:w-auto" data-id="element-96">
              <CTAButton className="w-full md:w-auto" data-id="element-97" />
              <p className="mt-4 text-sm text-gray-500 text-center md:text-left flex items-center justify-center md:justify-start gap-2" data-id="element-98">
                <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-99"></span>
                Acceso inmediato al PDF tras el pago seguro
              </p>
            </FadeIn>
          </div>

          <div className="order-1 md:order-2 relative" data-id="element-100">
            <FadeIn delay={0.3} direction="left" data-id="element-101">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-102">
                <img src="https://cdn.magicpatterns.com/uploads/pYKrFMeUBQ8x13gHW2sTdL/93244389-9c59-4c5c-a7e3-af311d3d4e73.jpg" alt="Reset Metabólico 45+ Guía Nutricional" className="w-full h-auto object-cover" data-id="element-103" />
                {/* Overlay gradient for premium feel */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-104"></div>
              </div>

              {/* Decorative badge */}
              <div className="absolute -bottom-6 -left-6 bg-brand-green text-white p-4 rounded-full shadow-xl flex flex-col items-center justify-center w-28 h-28 transform -rotate-12 border-4 border-brand-cream" data-id="element-105">
                <span className="font-bold text-xl" data-id="element-106">100%</span>
                <span className="text-xs text-center leading-tight" data-id="element-107">
                  Diseñado para 45+
                </span>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}